export enum BrowserWindowEvent {
  load = 'load',
  resize = 'resize',
  scroll = 'scroll',
  popstate = 'popstate',
  keyup = 'keyup',
  keydown = 'keydown',
  click = 'click',
}
